/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = parseInt(this.dataset.max) || 20;
      this.columns = parseInt(this.dataset.columns) || 6;
      this.enableCarousel = this.dataset.enableCarousel === 'true';
      this.products = '';

      // Garantiza que siempre sea un array, incluso en incógnito
      window.recentlyViewedIds = window.recentlyViewedIds || [];

      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof recentIds !== 'undefined') {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }

    connectedCallback() {
      this.buildUrl();
    }

    buildUrl() {
      const handles = [...window.recentlyViewedIds]
        .filter((val) => val && val !== this.currentId)
        .slice(0, this.max);

      handles.forEach((val) => {
        this.products += 'handle:' + val + ' OR ';
      });

      // Si no hay productos en historial, no hacer fetch
      if (!this.products.length) return;

      this.url = theme.routes.search_url
        + '?view=recently-viewed&type=product&limit='
        + this.max
        + '&q='
        + encodeURIComponent(this.products);

      this.fetchProducts();
    }

    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            // Ordenar en el fragmento desconectado del DOM, antes de insertar
            this.sortProducts(recommendations);
            this.prepareLayout(recommendations);
            this.classList.add('product-recommendations--loaded');
            // Notificar al padre product-recommendations que ya está listo
            this.closest('product-recommendations')?.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    sortProducts(container) {
      const orderedHandles = [...window.recentlyViewedIds]
        .filter(h => h && h !== this.currentId);
      const cards = [...container.querySelectorAll('[data-handle]')];

      const sortedCards = cards
        .sort((a, b) => {
          const indexA = orderedHandles.indexOf(a.dataset.handle);
          const indexB = orderedHandles.indexOf(b.dataset.handle);
          return indexA - indexB;
        })
        .slice(0, this.max);

      container.innerHTML = '';
      sortedCards.forEach(card => container.appendChild(card));
    }

    prepareLayout(recommendations) {
      const cards = [...recommendations.querySelectorAll('[data-handle]')];
      const columnsClass = this.getColumnsClass();
      const shouldUseCarousel = this.enableCarousel && cards.length > this.columns;

      cards.forEach((card) => {
        card.className = `${columnsClass} columns${shouldUseCarousel ? ' carousel__slide' : ''}`;
      });

      if (!shouldUseCarousel) {
        this.container.innerHTML = recommendations.innerHTML;
        return;
      }

      this.buildCarousel(recommendations);
    }

    getColumnsClass() {
      switch (this.columns) {
        case 2:
          return 'small-6 medium-6';
        case 3:
          return 'small-6 medium-4';
        case 4:
          return 'small-6 medium-6 large-3';
        case 5:
          return 'small-6 medium-3 large-1/5';
        case 6:
          return 'small-6 medium-3 large-2';
        default:
          return 'small-6 medium-3 large-2';
      }
    }

    // El carrusel usa el componente <slide-show> del tema (assets/slideshow.js),
    // con el mismo marcado que featured-collection: slides y flechas dentro
    // del elemento. Se construye vía innerHTML para que el constructor de
    // slide-show encuentre los slides al inicializar Flickity.
    buildCarousel(recommendations) {
      const navButtons = [...this.container.querySelectorAll('.flickity-nav')]
        .map((button) => button.outerHTML)
        .join('');

      const wrapper = document.createElement('div');
      wrapper.innerHTML = `<slide-show class="products row carousel">${recommendations.innerHTML}${navButtons}</slide-show>`;

      const slideShow = wrapper.firstElementChild;

      this.container.replaceWith(slideShow);
      this.container = slideShow;

      // En modo carrusel Flickity controla el desplazamiento también en móvil
      this.classList.remove('swipe-on-mobile');

      if (typeof Flickity === 'undefined') return;

      const flkty = Flickity.data(slideShow);

      if (!flkty) return;

      // El slide-show se inicializó fuera del DOM: recalcular medidas al insertar
      flkty.resize();
      document.fonts.ready.then(() => flkty.resize());

      this.addCarouselProgress(slideShow, flkty);
    }

    // Barra de progreso con el mismo marcado y comportamiento que slideshow.js;
    // se enlaza aquí porque el slide-show se construye después del fetch
    addCarouselProgress(slideShow, flkty) {
      const progress = document.createElement('div');
      progress.className = 'flickity-progress recently-viewed-products--progress';
      progress.innerHTML = '<div class="flickity-progress--bar"></div>';
      slideShow.after(progress);

      const progressBar = progress.querySelector('.flickity-progress--bar');

      flkty.on('scroll', (progressValue) => {
        progressValue = Math.max(0, Math.min(1, progressValue));
        progressBar.style.width = progressValue * 100 + '%';
      });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
